export var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["NOT_FOUND_CONTEXT"] = "\uC5D0\uB7EC! \uC0C1\uC704 \uC2A4\uCF54\uD504\uC5D0\uC11C CONTEXT\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4!";
})(ErrorMessage || (ErrorMessage = {}));
//# sourceMappingURL=messages.js.map